import { useEffect, useState } from 'react';
import { sportsApi } from '../SportsAuthContext';

let _subCache = null;

// Public base URL for shareable links: tenant subdomain on production,
// otherwise {origin}/book/{slug}.
export function usePublicBase(slug) {
  const [sub, setSub] = useState(_subCache);
  useEffect(() => {
    if (_subCache !== null) { setSub(_subCache); return; }
    sportsApi.get('/sports/settings')
      .then(r => { _subCache = r.data?.custom_subdomain || ''; setSub(_subCache); })
      .catch(() => { _subCache = ''; setSub(''); });
  }, []);
  const onProd = typeof window !== 'undefined' && window.location.hostname.endsWith('agri-books.com');
  if (sub && onProd) return `https://${sub}.agri-books.com`;
  return slug ? `${window.location.origin}/book/${slug}` : '';
}

export const shortEventUrl = (base, kind, shortCode, longUrl) =>
  base && shortCode ? `${base}/${kind}/${shortCode}` : longUrl;
